export default __webpack_public_path__ + "static/media/antelope-10-thumbnail.a0a65425.jpg";